import moment from 'moment';

export const NOTA_DATA_FORMAT = 'YYYYMMDD';

const isCalendarYmd = (raw) => /^\d{8}$/.test(raw);
const isCalendarDmy = (raw) => /^\d{2}-\d{2}-\d{4}$/.test(raw);
const isCalendarIso = (raw) => /^\d{4}-\d{2}-\d{2}$/.test(raw);
const isEpochMillis = (raw) => /^\d{12,}$/.test(raw);

const calendarMoment = (raw, format) => {
  const parsed = moment(raw, format, true);
  return parsed.isValid() ? parsed : null;
};

/**
 * Interpreta `nota.data` como dia de calendário.
 * Aceita YYYYMMDD, DD-MM-YYYY, YYYY-MM-DD e epoch legado (dia em UTC).
 */
export const parseNotaData = (value) => {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  if (isCalendarYmd(raw)) return calendarMoment(raw, NOTA_DATA_FORMAT);
  if (isCalendarDmy(raw)) return calendarMoment(raw, 'DD-MM-YYYY');
  if (isCalendarIso(raw)) return calendarMoment(raw, 'YYYY-MM-DD');
  if (isEpochMillis(raw)) {
    const utcDay = moment.utc(Number(raw));
    if (!utcDay.isValid()) return null;
    return moment(utcDay.format(NOTA_DATA_FORMAT), NOTA_DATA_FORMAT, true);
  }
  return null;
};

export const todayNotaData = () => moment().format(NOTA_DATA_FORMAT);

export const pickerValueToNotaData = (value) => {
  if (value == null || value === '') return null;
  if (moment.isMoment(value)) {
    return value.isValid() ? value.format(NOTA_DATA_FORMAT) : null;
  }
  const raw = String(value).trim();
  if (isCalendarYmd(raw) || isCalendarDmy(raw) || isCalendarIso(raw)) {
    const parsed = parseNotaData(raw);
    return parsed ? parsed.format(NOTA_DATA_FORMAT) : null;
  }
  const local = moment(Number(value));
  return local.isValid() ? local.format(NOTA_DATA_FORMAT) : null;
};

export const toNotaDataPayload = (value) => {
  if (value == null || value === '') return todayNotaData();
  const raw = String(value).trim();
  if (isEpochMillis(raw)) {
    const parsed = parseNotaData(raw);
    return parsed ? parsed.format(NOTA_DATA_FORMAT) : todayNotaData();
  }
  return pickerValueToNotaData(value) || todayNotaData();
};

export const notaDataToPickerValue = (value) => {
  const parsed = parseNotaData(value);
  return parsed ? parsed.valueOf() : null;
};

export const formatNotaDataDisplay = (value) => {
  const parsed = parseNotaData(value);
  return parsed ? parsed.format('DD/MM/YYYY') : '';
};

export const notaDataSortKey = (value) => {
  const parsed = parseNotaData(value);
  if (!parsed) return 0;
  return Number(parsed.format(NOTA_DATA_FORMAT));
};
